import { getSchema } from "@/api/common";
import parser from "@/utils/parser";

// schema mixins
export const schemaMixins = {
  data() {
    return {
      schema: null,
      userConfig: null,
      resources: null
    };
  },
  provide() {
    return {
      // 把组件本身的this传下去
      root: this,
      disableResource: this.disableResource,
      visibleResource: this.visibleResource,
      getLabel: this.getLabel
    };
  },
  created() {
    this.resourceCode && this.getSchemaByCode();
    this.rcCreated && this.rcCreated();
  },
  computed: {
    visibleResource() {
      return code => {
        return this.visibleRes(code, this.resources);
      };
    },
    disableResource() {
      return code => {
        return this.disableRes(code, this.resources);
      };
    },
    getLabel() {
      return code => {
        return this.getResLabel(code, this.resources);
      };
    }
  },
  methods: {
    rcCreated(){},
    // 根据code获取信息
    async getSchemaByCode() {
      try {
        const { data } = await getSchema(this.resourceCode);

        if (data) {
          const { content, formUserConfigs } = data;
          // json schema
          this.schema = parser.parse(content);
          // 用户级的设置
          this.userConfig = Object.freeze(formUserConfigs);
          // 旧的资源信息
          if (Array.isArray(this.schema.resources)) {
            this.resources = this.schema.resources || [];
            console.log(this.resources,123456)
          }
        }
      } catch (error) {
        throw error;
      }
    }
  }
};
